import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { SamplingReasonType } from "../../app/types/genericTables.types";

type UseSamplingReasonType = {
  samplingReasonList: SamplingReasonType[];
  get: (id: SamplingReasonType["id"]) => SamplingReasonType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useSamplingReason = create<UseSamplingReasonType>((set, get) => ({
  loading: false,
  samplingReasonList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().samplingReasonList.find((samplingReason) => samplingReason.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/MotivosMuestreo";
      const { data: response } = await getData(endpoint);
      set(() => ({
        samplingReasonList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useSamplingReason:", error);
      set({ loading: false });
    }
  },
}));
